<template>
    <v-modal :title="addOrEditText" @close="close" scroll>
        <div slot="contents">
            <div class="modal-content">
                <v-error-messages
                    :has-frontend-errors="$v.rate.$error"
                    class="stack-l">
                    <li class="list-item" v-if="!$v.rate.name.required">Rate name is required</li>
                    <li class="list-item" v-if="!$v.rate.price.required">Rate price is required</li>
                    <li class="list-item" v-if="!$v.rate.currency.required">Rate currency is required</li>
                    <li class="list-item" v-if="!$v.rate.price.decimal">Rate price must be a valid number</li>
                    <li class="list-item" v-if="!$v.rate.minOrderSubtotal.decimal">Rate minimum order subtotal must be a number</li>
                    <li class="list-item" v-if="!$v.rate.maxOrderSubtotal.minValue">Rate maximum order subtotal must be larger than minimum order subtotal</li>
                </v-error-messages>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            label="Name"
                            v-model="rate.name"
                            :validate="$v.rate.name"
                            :auto-focus="true"
                            help-text="The name customers will see at checkout"
                        />
                    </div>
                    <div class="grid-item grid-item-full">
                        <v-select
                            label="Currency"
                            preselect-first
                            placeholder="Type to search or select"
                            :options="currencies"
                            v-model="rate.currency"
                            :validate="$v.rate.currency"
                        />
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input
                            :left-label="selectedCurrencySign"
                            label="Minimum Order Subtotal"
                            v-model="rate.minOrderSubtotal"
                            :validate="$v.rate.minOrderSubtotal"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input
                            :left-label="selectedCurrencySign"
                            label="Maximum Order Subtotal"
                            placeholder="No Limit"
                            help-text="Leave field empty to set no limit"
                            v-model="rate.maxOrderSubtotal"
                            :validate="$v.rate.maxOrderSubtotal"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <r-input
                            :left-label="selectedCurrencySign"
                            label="Price"
                            help-text="Set field to 0 to provide free shipping"
                            v-model="rate.price"
                            :validate="$v.rate.price"/>
                    </div>
                </div>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="apply">{{addOrEditText}}</r-button>
        </template>
    </v-modal>
</template>

<script>
    import CURRENCIES, {CURRENCIES_LIST} from '@/data/currencies';
    import vModal from '@/components/modal/v-modal';
    import {
        vSelect, vErrorMessages,
    } from '@/components/form';
    import {required, decimal, minValue} from 'vuelidate/lib/validators';
    import ShippingZoneRateModel from '@/common/models/shipping-zone-rate-model';

    export default {
        props: {
            rateToEdit: {
                Object,
                default: null,
            },
        },
        components: {
            vModal,
            vSelect,
            vErrorMessages,
        },
        computed: {
            selectedCurrencySign() {
                if (this.rate.currency) {
                    return CURRENCIES.find(currency => this.rate.currency === currency.iso).sign;
                }
                return '$';
            },
            addOrEditText() {
                return this.rateToEdit ? 'Edit Rate' : 'Add Rate';
            },
        },
        validations() {
            return {
                rate: {
                    name: {
                        required,
                    },
                    currency: {
                        required,
                    },
                    minOrderSubtotal: {
                        decimal,
                    },
                    maxOrderSubtotal: {
                        decimal,
                        minValue: minValue(this.rate.minOrderSubtotal),
                    },
                    price: {
                        required,
                        decimal,
                    },
                },
            };
        },
        data() {
            return {
                rate: this.rateToEdit
                    ? new ShippingZoneRateModel(this.rateToEdit)
                    : new ShippingZoneRateModel({maxOrderSubtotal: null}),
                currencies: CURRENCIES_LIST,
            };
        },
        methods: {
            close() {
                this.$emit('close');
            },
            apply() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.$emit('input', this.rate);
                    this.$emit('close');
                }
            },
        },
    };
</script>
